import { Teacher } from '../../../types/Teacher';
import { teacherAdapter } from '../mappers/teachers';
import { TeachersFilters } from '../../interfaces/EstudiApiClient/dtos/TeachersFilters';

const serializeAvailableIn = (slots: { startTime: string; endTime: string }[]): string => {
  return slots.map(({ startTime, endTime }) => `${startTime},${endTime}`).join(';');
};

const fetchTeachers = async (params: TeachersFilters): Promise<{ teachers: Teacher[] }> => {
  const searchParams = new URLSearchParams();

  searchParams.set('courseId', params.courseId);

  if (params.minPricePerHour !== undefined) {
    searchParams.set('minPricePerHour', params.minPricePerHour.toString());
  }

  if (params.maxPricePerHour !== undefined) {
    searchParams.set('maxPricePerHour', params.maxPricePerHour.toString());
  }

  if (params.modality) {
    searchParams.set('modality', params.modality);
  }

  if (params.type && params.type !== 'all') {
    searchParams.set('type', params.type);
  }

  if (params.availableIn && params.availableIn.length > 0) {
    searchParams.set('availableIn', serializeAvailableIn(params.availableIn));
  }

  try {
    const response = await fetch(
      `${
        process.env.REACT_APP_ESTUDI_API_URL
      }/estudi/web/teachers/search?${searchParams.toString()}`
    );

    return await response.json();
  } catch (error) {
    console.error(error);

    return Promise.reject();
  }
};

export const teachersQueryFunction = (params: TeachersFilters) => ({
  queryKey: [params.courseId, 'teachers', JSON.stringify(params)],
  queryFn: async (): Promise<Teacher[]> =>
    fetchTeachers(params).then((response) =>
      response.teachers.map((teacher: Teacher) => teacherAdapter(teacher))
    )
});
